module.exports = __webpack_public_path__ + "static/media/Advent01.ff582766.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Advent01.jpg
// module id = 365
// module chunks = 0